import { ScreenplayEntity } from '@/shared/lib/db'
import { LexicalEditor } from 'lexical'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { Position, SuggestionListItem } from '../components/type'

type FeatureEnabled = {
    aiCompletion: boolean
    nodeToolbar: boolean
    suggestionDropdown: boolean
}

interface SpEditorState {
    htmlString: string
    featuresEnabled: FeatureEnabled
    suggestionProps: {
        coords: Position | undefined
        options: SuggestionListItem[]
    }
    screenplayEntity: ScreenplayEntity | undefined

    setEditor: (editor: LexicalEditor | null) => void
    setHtmlString: (html: string) => void
    setFeaturesEnabled: (features: FeatureEnabled) => void
    updateFeatureEnabled: (features: FeatureEnabled) => void
    setSuggestionProps: (props: { coords: Position | undefined, options: SuggestionListItem[] }) => void
    setScreenplayEntity: (entity: ScreenplayEntity | undefined) => void

    isOutlineDialogOpen: boolean
    setIsOutlineDialogOpen: (open: boolean) => void
    isChoiceDialogOpen: boolean
    setIsChoiceDialogOpen: (open: boolean) => void
}

export const useSpEditorStore = create<SpEditorState>()(
    devtools((set) => ({
        htmlString: '',
        featuresEnabled: {
            aiCompletion: false,
            nodeToolbar: false,
            suggestionDropdown: false,
        },
        suggestionProps: {
            coords: undefined,
            options: [],
        },
        screenplayEntity: undefined,

        setHtmlString: (htmlString) => set({ htmlString }),
        setFeaturesEnabled: (featuresEnabled) => set({ featuresEnabled }),
        updateFeatureEnabled: (features) => {
            localStorage.setItem('spFeaturesEnabled', JSON.stringify(features))
            set({ featuresEnabled: features })
        },
        setSuggestionProps: (suggestionProps) => set({ suggestionProps }),
        setScreenplayEntity: (screenplayEntity) => set({ screenplayEntity }),

        isOutlineDialogOpen: false,
        setIsOutlineDialogOpen: (open: boolean) => set({ isOutlineDialogOpen: open }),
        isChoiceDialogOpen: false,
        setIsChoiceDialogOpen: (open: boolean) => set({ isChoiceDialogOpen: open }),
    }))
)
